import React from 'react';
import './Skills.css';
import { skillsData } from '../data/portfolioData';

import { FaAws, FaDocker, FaPython, FaJava, FaLinux } from 'react-icons/fa';
import {
  SiTypescript, SiPostgresql, SiMysql, SiKubernetes, SiGooglecloud,
  SiPytorch, SiTensorflow, SiScikitlearn, SiMongodb, SiRedis,
  SiElasticsearch, SiNeo4J, SiTerraform, SiGithubactions,
  SiApachespark, SiApachekafka, SiApacheairflow, SiPandas, SiNumpy,
  SiJupyter, SiGit, SiOpencv, SiCplusplus, SiGnubash,
  SiFastapi, SiHuggingface, SiDbt, SiMlflow, SiWeightsandbiases,
  SiAmazondynamodb, SiLangchain, SiSpacy, SiSqlite,
  SiKeras, SiOnnx, SiScipy, SiPlotly,
  SiSnowflake, SiApachecassandra, SiFirebase, SiSupabase,
} from 'react-icons/si';
import { TbVectorTriangle } from 'react-icons/tb';

const iconMap: { [key: string]: JSX.Element } = {
  FaPython: <FaPython />,
  FaAws: <FaAws />,
  FaDocker: <FaDocker />,
  FaJava: <FaJava />,
  FaLinux: <FaLinux />,
  SiTypescript: <SiTypescript />,
  SiPostgresql: <SiPostgresql />,
  SiMysql: <SiMysql />,
  SiKubernetes: <SiKubernetes />,
  SiGooglecloud: <SiGooglecloud />,
  SiPytorch: <SiPytorch />,
  SiTensorflow: <SiTensorflow />,
  SiScikitlearn: <SiScikitlearn />,
  SiMongodb: <SiMongodb />,
  SiRedis: <SiRedis />,
  SiElasticsearch: <SiElasticsearch />,
  SiNeo4j: <SiNeo4J />,
  SiTerraform: <SiTerraform />,
  SiGithubactions: <SiGithubactions />,
  SiApachespark: <SiApachespark />,
  SiApachekafka: <SiApachekafka />,
  SiApacheairflow: <SiApacheairflow />,
  SiPandas: <SiPandas />,
  SiNumpy: <SiNumpy />,
  SiJupyter: <SiJupyter />,
  SiGit: <SiGit />,
  SiOpencv: <SiOpencv />,
  SiCplusplus: <SiCplusplus />,
  SiGnubash: <SiGnubash />,
  SiFastapi: <SiFastapi />,
  SiHuggingface: <SiHuggingface />,
  SiDbt: <SiDbt />,
  SiMlflow: <SiMlflow />,
  SiWeightsandbiases: <SiWeightsandbiases />,
  SiPinecone: <TbVectorTriangle />,
  SiAmazondynamodb: <SiAmazondynamodb />,
  SiLangchain: <SiLangchain />,
  SiSpacy: <SiSpacy />,
  SiSqlite: <SiSqlite />,
  SiXgboost: <SiPytorch />, // fallback
  SiKeras: <SiKeras />,
  SiOnnx: <SiOnnx />,
  SiScipy: <SiScipy />,
  SiPlotly: <SiPlotly />,
  SiSnowflake: <SiSnowflake />,
  SiApachecassandra: <SiApachecassandra />,
  SiFirebase: <SiFirebase />,
  SiSupabase: <SiSupabase />,
};

const Skills: React.FC = () => {
  const skillsByCategory = skillsData.reduce((acc: any, skill: any) => {
    if (!acc[skill.category]) acc[skill.category] = [];
    acc[skill.category].push(skill);
    return acc;
  }, {});

  return (
    <div className="skills-page">
      <div className="skills-header">
        <h1 className="skills-page-title">Skills & Technologies</h1>
        <p className="skills-subtitle">Technologies I use to build intelligent systems at scale</p>
      </div>
      <div className="skills-container">
        {Object.keys(skillsByCategory).map((category, index) => (
          <div key={index} className="skill-category" style={{ animationDelay: `${index * 0.15}s` }}>
            <div className="category-header">
              <h3 className="category-title">{category}</h3>
            </div>
            <div className="skills-grid">
              {skillsByCategory[category].map((skill: any, idx: number) => (
                <div key={idx} className="skill-card" style={{ animationDelay: `${index * 0.15 + idx * 0.06}s` }}>
                  <div className="skill-icon">{iconMap[skill.icon] || <FaPython />}</div>
                  <span className="skill-name">{skill.name}</span>
                  <span className="skill-desc">{skill.description}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
